/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { TablePagination, Grid } from '@material-ui/core';

/**
 * region for styles*/
import { paginationStyle } from './style/paginationStyle';

class Pagination extends Component {
    render() {
        const { classes } = this.props;
        return (
            <Grid item xs={12} className={classes.contentInitalTextSearch}>
                <TablePagination
                    rowsPerPageOptions={[50]}
                    component="div"
                    count={this.props.totalFound}
                    rowsPerPage={this.props.pageSize}
                    page={this.props.pageNumber - 1}
                    onChangePage={this.props.handleChangePage}
                    backIconButtonProps={{
                        'aria-label': 'previous page'
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'next page'
                    }} />
            </Grid>
        );
    }
}
Pagination.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(paginationStyle)(Pagination);